// extracted by mini-css-extract-plugin
export default {"wrapper":"morning-content_wrapper__iVPeH","h1":"morning-content_h1__3SoMD","h3":"morning-content_h3__gQbcc"};